const lowercaseTitleWords = new Set('a an the and but or nor for so yet as at by in of on per to via with without about from into onto over than is am are was were be been being'.split(' '))

export function formatClipTitle(title: string): string {
  let firstWord = true
  const displayTitle = title.replace(/\s*\u2014\s*/g, ', ')
  return displayTitle.replace(/\b[A-Za-z]+\b/g, (word, offset: number) => {
    const first = firstWord
    firstWord = false
    const seriesLabel = word === 'A' && /\bSeries\s+$/i.test(displayTitle.slice(0, offset))
    const startsSubtitle = /:\s*$/.test(displayTitle.slice(0, offset))
    return !first && !seriesLabel && !startsSubtitle && lowercaseTitleWords.has(word.toLowerCase()) ? word.toLowerCase() : word
  })
}
